module.exports = __webpack_public_path__ + "img/clientes.88025360.svg";